import { portalRoles } from '../enums/portalRoles';
import Vue from 'vue';

export const getPortalRoleText = portalRole => {
  switch (portalRole) {
    case portalRoles.EMPLOYEE:
      return Vue.prototype.$getText('SEARCH_RECIPIENT_EMPLOYEE');
    case portalRoles.CHILD:
      return Vue.prototype.$getText('SEARCH_RECIPIENT_CHILDREN');
    case portalRoles.GUARDIAN:
      return Vue.prototype.$getText('SEARCH_RECIPIENT_GUARDIAN');
    default:
      return '';
  }
};
